module.exports = __webpack_public_path__ + "static/media/bullet-red.0d4eaebc.svg";